// =======================================
//  Alpine js components:
// =======================================
document.addEventListener('alpine:init', () => {
  Alpine.data('promotionApp', (promoCode, promoSaving, promoThreshold) => ({
    showArrow: false,
    promoCode: promoCode,
    promoSaving: promoSaving,
    promoThreshold: promoThreshold,
    init() {
      this.showArrow = this.$refs.promotionContent.scrollWidth > this.$refs.promotionContent.clientWidth;
    },
    showModal() {
      this.$dispatch('promotion:open', {promoCode: promoCode, promoSaving: promoSaving, promoThreshold: promoThreshold});
    }
  })
  )
})